module.exports = __webpack_public_path__ + "img/IMG_8512_P_L_Foamcore_MockedUp.6ed69b10.jpg";